import Dialog from '@/components/Dialog';
import styled from '@emotion/styled';

const AttachmentSection = styled(Dialog.Content)({
  flexShrink: 0,
  ':not(:last-of-type)': {
    paddingBottom: 10,
  },
});

export default AttachmentSection;
